import React, {PropTypes} from "react";
import {connect} from 'react-redux';
//comment

class FeedbackSubmit extends React.Component {
	render() {
			return ( <h2 className="successBtn text-center text-success">Thanks for submitting your feedback.</h2>);
	}
}
export default FeedbackSubmit;


/** WEBPACK FOOTER **
 ** ./src/feature/feedback/feedbackSubmit.js
 **/